module.exports = __webpack_public_path__ + "static/media/route-package-protection.bfc66c53.svg";